import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";

import { store } from "../../../../components/VerticalLayout/store";
import { store as dataStore } from "../store";

import { capitalize } from "../../../../helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { handleAssociateLogoButtonClick } from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

type ConfirmationAssociatedMessageType = {
    isConfirmationModal: boolean;
    setIsConfiramationModal: Function;
    selectedRows: any;
    idShops: string[];
    setIsUpdatedModification: Function;
    setIsAssociateLogoOpened: Function;
    setIsValidateClickedModal: Function;
    setSelectedRows: Function;
};

export function ConfirmationAssociatedMessage({
    isConfirmationModal,
    setIsConfiramationModal,
    selectedRows,
    idShops,
    setIsUpdatedModification,
    setIsAssociateLogoOpened,
    setIsValidateClickedModal,
    setSelectedRows,
}: ConfirmationAssociatedMessageType) {
    const { t } = useTranslation();
    const { franchiseID, userID, operatorID } = useSnapshot(store);
    const { activeLogo, salesSupports } = useSnapshot(dataStore);
    const { fetchGlobal } = useFetchGlobal();
    const uuidUser = localStorage.getItem("uuidUser");

    return (
        <StyledModal toggle={true} isOpen={isConfirmationModal!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => setIsConfiramationModal(!isConfirmationModal)}
            >
                <span>{capitalize(t("Alert"))}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t(
                        "Attention! One or more selected logos are already assigned and archived at the store level.Would you unarchive them?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsConfiramationModal(!isConfirmationModal);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        handleAssociateLogoButtonClick(idShops,selectedRows,salesSupports,activeLogo,
                            userID,franchiseID,operatorID,uuidUser,setSelectedRows,setIsValidateClickedModal,
                            setIsUpdatedModification,fetchGlobal
                        )
                        setIsConfiramationModal(!isConfirmationModal);
                        setIsAssociateLogoOpened(false);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
